import React, { Suspense, useContext } from 'react';
import dynamic from 'next/dynamic';
import { Trans } from '@lingui/react';
import gql from 'graphql-tag';
import { TextWithIcon } from '@components/TextWithIcon';
import { UserContext } from '@lib/contexts/UserProvider';
import Spinner from '@components/Spinner';
import { useMutation } from '@apollo/client';
import useLoginModal from '@lib/hooks/useLoginModal';

const ScheduleModal = dynamic(
  () => import('@organisms/modals/schedule/ScheduleModal'),
  {
    ssr: false,
  }
);

const ADD_VIDEO_TO_SCHEDULE = gql`
  mutation addUserSchedule(
    $resourceId: ID!
    $datetime: ISO8601DateTime!
    $returnFormat: String!
  ) {
    addUserSchedule(
      resourceId: $resourceId
      datetime: $datetime
      returnFormat: $returnFormat
    ) {
      result
      filename
    }
  }
`;

const ButtonScheduleModal = ({ className = '', tagParams = {}, ...props }) => {
  const [addUserSchedule] = useMutation(ADD_VIDEO_TO_SCHEDULE);
  const [login_modal, { openModal }] = useLoginModal();
  const [currentUser] = useContext(UserContext);

  const { tag: DynamicComponent } = props;

  if (!currentUser?.id) {
    return (
      <>
        <DynamicComponent
          className={className}
          onClick={() => {
            openModal();
          }}
          {...tagParams}
        >
          <TextWithIcon icon="ygb-icon-calendar-o" iconSize="15px">
            <Trans id="menu_more.schedule" message={'Schedule'} />
          </TextWithIcon>
        </DynamicComponent>
        {login_modal}
      </>
    );
  }

  const onModalClose = () => {
    if (props.onModalClose) {
      props.onModalClose();
    }
  };

  return (
    <ScheduleModal
      resourceId={props.resourceId}
      onModalClose={onModalClose}
      handleSchedule={({ datetime, returnFormat }) => {
        return addUserSchedule({
          variables: {
            resourceId: props.resourceId,
            datetime,
            returnFormat,
          },
        });
      }}
    >
      {(handleOpenModal) => (
        <DynamicComponent
          className={className}
          onClick={handleOpenModal}
          {...tagParams}
        >
          <TextWithIcon icon="ygb-icon-calendar-o" iconSize="15px">
            <Trans id="menu_more.schedule" message="Schedule" />
          </TextWithIcon>
        </DynamicComponent>
      )}
    </ScheduleModal>
  );
};

export default ButtonScheduleModal;
